import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// A standalone "Custom range" dropdown + two-month flatpickr calendar --
// the same calendar-pane UX as period_filter_controller.js's own "Custom
// range" pane, extracted as its own small controller so it can sit next to
// the unmodified preset-button row on the rank tracker's heatmap
// (app/views/sonar/_heatmap.html.erb) without touching
// date_range_controller.js, which is shared with 3 PPC pages that have no
// calendar UI at all.
export default class extends Controller {
  static targets = ["toggle", "calendarMount", "startInput", "endInput", "applyButton"]
  static values = { dateFrom: String, dateTo: String, today: String, preserveParams: Boolean }

  connect() {
    this.element.addEventListener("shown.bs.dropdown", () => this.ensureCalendar())
  }

  disconnect() {
    this._fp?.destroy()
  }

  ensureCalendar() {
    if (this._fp) return

    this.startInputTarget.value = this.dateFromValue
    this.endInputTarget.value = this.dateToValue
    this._fp = flatpickr(this.calendarMountTarget, {
      inline: true,
      mode: "range",
      showMonths: 2,
      dateFormat: "Y-m-d",
      maxDate: this.todayValue,
      defaultDate: [ this.dateFromValue, this.dateToValue ],
      onChange: (selectedDates) => this.onCalendarChange(selectedDates)
    })
  }

  onCalendarChange(selectedDates) {
    if (selectedDates[0]) this.startInputTarget.value = flatpickr.formatDate(selectedDates[0], "Y-m-d")
    if (selectedDates[1]) this.endInputTarget.value = flatpickr.formatDate(selectedDates[1], "Y-m-d")
    this.applyButtonTarget.disabled = selectedDates.length < 2
  }

  startInputChanged() {
    this.syncCalendarFromInputs()
  }

  endInputChanged() {
    this.syncCalendarFromInputs()
  }

  syncCalendarFromInputs() {
    const start = this.startInputTarget.value
    const end = this.endInputTarget.value || start
    if (!start) return

    this._fp.setDate([ start, end ], true)
    this.applyButtonTarget.disabled = !(start && this.endInputTarget.value)
  }

  apply() {
    // Pages with other query state (selected product, tab) keep it when only the range changes
    const params = this.preserveParamsValue ? new URLSearchParams(window.location.search) : new URLSearchParams()
    params.set("date_from", this.startInputTarget.value)
    params.set("date_to", this.endInputTarget.value)
    window.location.href = `${window.location.pathname}?${params.toString()}`
  }

  cancel() {
    bootstrap.Dropdown.getOrCreateInstance(this.toggleTarget).hide()
  }
}
